import cx from "classnames";
import EmojiPicker, { Theme } from "emoji-picker-react";
import { type FC, useState } from "react";

import { FaceActivatedAddIcon } from "@moment/icons";

import { type ButtonSize } from "../Button";
import { buttonClassBase, buttonClassSizes, buttonClassStyles } from "../Button/buttonClasses";
import { Icon } from "../Icon";
import { Popover } from "../PopoverV2";
import { useTheme } from "../ThemeProvider";

export interface EmojiDropdownProps {
	withPortal?: boolean;
	onSelect?: (emoji: string, emojiName: string) => void;
	size?: ButtonSize;
}
export const EmojiDropdown: FC<EmojiDropdownProps> = ({
	withPortal = true,
	onSelect,
	size = "md",
}) => {
	const { resolvedTheme } = useTheme();
	const [isOpen, setIsOpen] = useState(false);

	const openDropdown = () => setIsOpen(true);
	const closeDropdown = () => setIsOpen(false);

	const content = (
		<Popover.Content asChild onInteractOutside={closeDropdown} onEscapeKeyDown={closeDropdown}>
			<EmojiPicker
				className=""
				theme={resolvedTheme === "light" ? Theme.LIGHT : Theme.DARK}
				onEmojiClick={(emojiData) => {
					onSelect?.(
						emojiData.emoji,
						emojiData.names?.[0]
							? `:${emojiData.names[0].replace(/ /g, "_")}:`
							: "(unknown)"
					);
					setIsOpen(false);
				}}
				previewConfig={{ defaultCaption: "" }}
			/>
		</Popover.Content>
	);

	return (
		<Popover.Root open={isOpen}>
			<Popover.Trigger onClick={openDropdown} aria-label="Select Emoji">
				<div
					className={cx(
						buttonClassBase({ fullWidth: false, level: "secondary" }),
						buttonClassSizes(size, "secondary", true, false),
						buttonClassStyles("normal", "secondary", "default", false)
					)}
				>
					<Icon icon={FaceActivatedAddIcon} />
				</div>
			</Popover.Trigger>
			{withPortal ? <Popover.Portal>{content}</Popover.Portal> : content}
		</Popover.Root>
	);
};
